import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import Routes from 'bundles/account-settings/routes';
import EnterCardFormStore from 'bundles/account-settings/stores/EnterCardFormStore';
import HighlightSettingsStore from 'bundles/account-settings/stores/HighlightSettingsStore';
import UnsubscribeStore from 'bundles/account-settings/stores/UnsubscribeStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import AccountLinkStore from 'bundles/third-party-auth/stores/AccountLinkStore';

// remove the grid import once all bt3-container, bt3-row, and bt3-col classes are removed from this bundle
import 'css!bundles/account-settings/styl/grid';
import 'css!bundles/global-styles/global-element-styles';

const app = new Fluxible({
  component: Routes,
});

app.registerStore(ApplicationStore);
app.registerStore(EnterCardFormStore);
app.registerStore(NaptimeStore);
app.registerStore(AccountLinkStore);
app.registerStore(UnsubscribeStore);
app.registerStore(HighlightSettingsStore);

export default app;
